/** Static default art for home HUD (served from /public). */
export const HOME_ASSETS = {
  avatarDefault: "/assets/images/home/avatar-default.svg",
  coin: "/assets/images/home/resource-coin.svg",
  gem: "/assets/images/home/resource-gem.svg",
  heart: "/assets/images/home/resource-heart.svg",
  combatAutoSwords: "/assets/images/combat/auto-combat-swords.png",
  combatSitMeditate: "/assets/images/combat/combat-sit-meditate.png",
  /** 3D rail menu icons (5×2 sheet split). */
  railIcons: {
    decorate: "/assets/images/home/rail-icons/rail-decorate.png",
    character: "/assets/images/home/rail-icons/rail-character.png",
    skill: "/assets/images/home/rail-icons/rail-skill.png",
    tower: "/assets/images/home/rail-icons/rail-tower.png",
    dungeon: "/assets/images/home/rail-icons/rail-dungeon.png",
    rank: "/assets/images/home/rail-icons/rail-rank.png",
    raid: "/assets/images/home/rail-icons/rail-raid.png",
    shop: "/assets/images/home/rail-icons/rail-shop.png",
    stash: "/assets/images/home/rail-icons/rail-stash.png",
    more: "/assets/images/home/rail-icons/rail-more.png",
  },
  shopTabs: {
    all: "/assets/images/home/icons/cat-all.svg",
    backdrop: "/assets/images/home/icons/cat-backdrop.svg",
    shell: "/assets/images/home/icons/cat-backdrop.svg",
    floor: "/assets/images/home/icons/cat-floor.svg",
    solid: "/assets/images/home/icons/cat-solid.svg",
    prop: "/assets/images/home/icons/cat-prop.svg",
    platform: "/assets/images/home/icons/cat-platform.svg",
    attack_dummy: "/assets/images/home/icons/cat-attack-dummy.svg",
    monster: "/assets/images/home/icons/cat-monster.svg",
  },
} as const;

/** @deprecated Prefer totalCatalogCap() from economy — kept for badge fallback. */
export const HOME_FURNITURE_MAX = 30;

/** Former system room art paths — ignore when loading saved rooms. */
export const LEGACY_SYSTEM_ROOM_URLS = new Set([
  "/assets/images/home/room-ambient.svg",
  "/assets/images/home/room-dusk.svg",
  "/assets/images/home/room-mist.svg",
  "/assets/images/home/room-ambient.jpg",
  "/assets/images/home/room-dusk.jpg",
  "/assets/images/home/room-mist.jpg",
]);
